import { useEffect, useState } from "react";
import {
  GoabCircularProgress,
  GoabBlock,
  GoabSpacer,
  GoabButtonGroup,
  GoabButton,
  GoabModal,
} from "@abgov/react-components";
import ApplicationComponent from "./ApplicationComponent";
import NewApplicationListComponent from "./NewApplicationListComponent";
import { getAvailableProgramEvents } from "../../MPP-Common-SPA/utils/getAvailableProgramEvents";
import {
  StatusTransitionEventEnum,
  InternalApplicationStatuses,
} from "../../MPP-Common-SPA/common/constants/statuses";

const ApplicationList = (props) => {
  const {
    applicationList = [],
    isLoading,
    programEvents,
    handleWithdrawApplication,
    getResourceValue,
    program,
    user,
    isEventsEnabled,
  } = props;
  const availableEvents = getAvailableProgramEvents(
    programEvents,
    applicationList,
  );
  const [showResubmitModal, setShowResubmitModal] = useState(false);

  useEffect(() => {
    if (!isLoading && applicationList?.length > 0) {
      const hasSubmittedToDraft = applicationList.some(
        (app) =>
          app.statusTransitionEvent ===
            StatusTransitionEventEnum.SubmittedToDraft &&
          app.internalStatus === InternalApplicationStatuses.Draft,
      );

      setShowResubmitModal(hasSubmittedToDraft);
    }
  }, [isLoading, applicationList]);

  return (
    <>
      <GoabModal
        heading="Review your applications"
        open={showResubmitModal}
        calloutVariant="important"
        onClose={() => setShowResubmitModal(false)}
        actions={
          <GoabButtonGroup alignment="end">
            <GoabButton
              type="primary"
              onClick={() => setShowResubmitModal(false)}
            >
              Continue
            </GoabButton>
          </GoabButtonGroup>
        }
      >
        <p>
          One or more of your applications have been updated and moved back to a
          draft state.
        </p>
        <br></br>
        <p>Please review the information in your applications.</p>
      </GoabModal>
      <GoabCircularProgress
        variant="fullscreen"
        visible={isLoading}
        message={getResourceValue({ key: "RESOURCES@global.loading" })}
      />
      {!isLoading && applicationList?.length > 0 && (
        <>
          {applicationList.map((application) => (
            <ApplicationComponent
              key={application.id}
              program={program}
              application={application}
              programEvents={programEvents}
              availableEvents={availableEvents}
              handleWithdrawApplication={handleWithdrawApplication}
            />
          ))}
        </>
      )}
      {!isLoading && applicationList?.length === 0 && (
        <GoabBlock direction="column" gap="2xl" alignment="center">
          <img
            src="/Images/paymentInfo.svg"
            alt=""
            style={{ width: "278px", height: "137px" }}
          />
          <h3 className="secondary">
            {getResourceValue({
              key: "RESOURCES@myApplications.noActiveApplications",
            })}
          </h3>
        </GoabBlock>
      )}
      {!applicationList && (
        <GoabBlock direction="column" gap="m" alignment="center">
          <GoabSpacer vSpacing="xl" />
          <h3>Failed to load applications.</h3>
        </GoabBlock>
      )}
      <NewApplicationListComponent
        availableEvents={availableEvents}
        getResourceValue={getResourceValue}
        program={program}
        user={user}
        applicationList={applicationList}
        isEventsEnabled={isEventsEnabled}
      />
      <GoabSpacer vSpacing="3xl" />
    </>
  );
};

export default ApplicationList;
